// import mixinPoster from './posterBase'
// import mixinPosterCard from './posterCard'
// import mixinPosterCanvas from './posterCanvas'
// import mixinUpload from './upload'
import mixinScreen from './screen'
import mixinSession from './session'

export {
  // mixinPoster,
  // mixinPosterCard,
  // mixinPosterCanvas,
  // mixinUpload,
  mixinScreen,
  mixinSession
}



// WEBPACK FOOTER //
// ./src/mixin/index.js